/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import {
  ActivatedRoute,
  Params,
  Router,
  Event,
  NavigationEnd
} from '@angular/router';

import { Observable, Subject, Subscription } from 'rxjs';
import { User } from 'app/models/User';
import { EventBusService } from 'app/services/EventBusService';
import { WatchlistService } from 'app/services/watchlist-service';
import { ChangelogService } from 'app/services/changelog-service';
import { ApigeeService } from 'app/services/apigee.service';
import { AppInjector } from 'app/services/app-injector.service';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { AuthService, AuthState } from 'app/services/auth.service';
import { Meta, Title } from '@angular/platform-browser';
import { SideNavItem } from 'app/models/SideNavItem';
import { TrackingService } from 'app/services/tracking.service';
import {
  ScrollDirection,
  ScrollTriggerService
} from 'app/services/scroll-trigger.service';
import { map, takeUntil } from 'rxjs/operators';
import { DetailsPageSectionDirective } from './directives/details-page-section.directive';
import { DetailsPageHeaderDirective } from './directives/details-page-header.directive';
import { RouterUtilityService } from 'app/services/router-utility.service';
import {
  PageMetaService,
  StructuredAppData,
  StructuredDomainData,
  StructuredSellerData
} from 'app/services/page-meta.service';
import { AppNavigationService } from '../../../../services/app-navigation.service';
import {
  Breakpoint,
  MediaQueryService
} from '../../../../services/media-query.service';
import { SwiperComponent } from 'swiper/angular';
import { FollowService } from 'app/services/follow.service';
import { Swiper } from 'swiper';
import { MobileScrollService } from 'app/services/mobile-scroll.service';

declare let jQuery;

export declare interface ResizeObserverMapping {
  [slideIndex: number]: ResizeObserver;
}

@Component({
  selector: 'details-page-base',
  template: '',
  styleUrls: ['./details-page.component.scss']
})
export abstract class DetailsPageComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  protected _router: Router;
  private _userService: User;
  protected _authService: AuthService;
  protected _tracking: TrackingService;
  protected _eventBus: EventBusService;
  protected _watchlistService: WatchlistService;
  protected _changelogService: ChangelogService;
  protected _apigeeService: ApigeeService;
  protected _scrollTrigger: ScrollTriggerService;
  protected _routerUtility: RouterUtilityService;
  protected _pageMetaService: PageMetaService;
  protected _appNavService: AppNavigationService;
  protected _mediaQueryService: MediaQueryService;
  protected _followService: FollowService;
  protected _mobileScrollService: MobileScrollService;

  protected _title: Title;
  protected _meta: Meta;

  private _isFollowing = false;
  private _isProcessing = false;

  private _data: any;
  private _appId: string;
  private _trackingId: string;
  private _type: string;
  private _showMobileNav: boolean;
  private _dataUpdateRequested = false;

  protected _scrollRequest: string;
  protected _postLoadScrollRequest: string;

  private _onQueryParams: Subscription;
  private _onWatchlistUpdate: Subscription;
  private _onRouterEvent: Subscription;
  private _onRouterParamsChange: Subscription;
  private _onRouterFragmentChange: Subscription;
  private _onAuthStateChange: Subscription;

  @ViewChildren(DetailsPageSectionDirective)
  protected pageSections!: QueryList<DetailsPageSectionDirective>;
  @ViewChild(DetailsPageHeaderDirective)
  protected pageHeader: DetailsPageHeaderDirective;

  @ViewChild('followButton') protected followButton: ElementRef<HTMLElement>;
  @ViewChild('swiper', { static: false }) protected swiper?: SwiperComponent;

  private _tempActiveSectionLock: string = null;
  private _initialScrollSection: string = null;

  abstract sideNavItems: SideNavItem[];

  public activeSection: string = null;
  public activeSectionHint = 'overview';
  private _sectionsInView: Element[] = [];
  private _currentTriggers: any[] = [];

  public mobileFilterBreakpointReached: boolean;
  public followBreakpointReached: boolean;
  public enabledSectionIds$!: Observable<string[]>;

  public lastScrollDirection: ScrollDirection;

  private destroyToken: Subject<void>;

  public desktop$: Observable<boolean>;
  public tablet$: Observable<boolean>;
  public mobile$: Observable<boolean>;

  resizeObservers: ResizeObserverMapping = {};

  constructor(
    protected _route: ActivatedRoute,
    protected _el: ElementRef,
    @Inject(String) private _insightsPermission: string
  ) {
    this._router = AppInjector.injector.get(Router);
    this._userService = AppInjector.injector.get(User);
    this._authService = AppInjector.injector.get(AuthService);
    this._tracking = AppInjector.injector.get(TrackingService);
    this._eventBus = AppInjector.injector.get(EventBusService);
    this._watchlistService = AppInjector.injector.get(WatchlistService);
    this._changelogService = AppInjector.injector.get(ChangelogService);
    this._apigeeService = AppInjector.injector.get(ApigeeService);
    this._scrollTrigger = AppInjector.injector.get(ScrollTriggerService);
    this._routerUtility = AppInjector.injector.get(RouterUtilityService);
    this._pageMetaService = AppInjector.injector.get(PageMetaService);
    this._appNavService = AppInjector.injector.get(AppNavigationService);
    this._mediaQueryService = AppInjector.injector.get(MediaQueryService);
    this._followService = AppInjector.injector.get(FollowService);
    this._mobileScrollService = AppInjector.injector.get(MobileScrollService);

    this._title = AppInjector.injector.get(Title);
    this._meta = AppInjector.injector.get(Meta);
  }

  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get trackingId(): string {
    return this._trackingId;
  }

  set trackingId(value: string) {
    this._trackingId = value;
  }

  get userService(): User {
    return this._userService;
  }

  set userService(value: User) {
    this._userService = value;
  }

  get mediaQueryService(): MediaQueryService {
    return this._mediaQueryService;
  }

  set mediaQueryService(mediaQueryService: MediaQueryService) {
    this._mediaQueryService = mediaQueryService;
  }

  get appId(): string {
    return this._appId;
  }

  set appId(value: string) {
    this._appId = value;
  }

  get isFollowing(): boolean {
    return this._isFollowing;
  }

  set isFollowing(value: boolean) {
    this._isFollowing = value;
  }

  get isProcessing(): boolean {
    return this._isProcessing;
  }

  set isProcessing(value: boolean) {
    this._isProcessing = value;
  }

  get showMobileNav(): boolean {
    return this._showMobileNav;
  }

  set showMobileNav(value: boolean) {
    this._showMobileNav = value;
    this._mobileScrollService.toggleSideNav(value);
  }

  get isFreemium(): boolean {
    return (
      this._userService.isFreemium() ||
      !this._userService.hasPermission(this._insightsPermission)
    );
  }

  get isAnonymous(): boolean {
    return this._userService.isAnonymous();
  }

  get insightsData(): any {
    return this._data;
  }

  set insightsData(value: any) {
    this._data = value;
  }

  get dataUpdateRequested(): boolean {
    return this._dataUpdateRequested;
  }

  set dataUpdateRequested(value: boolean) {
    this._dataUpdateRequested = value;
  }

  requestDataUpdate() {
    this.dataUpdateRequested = true;
  }

  ngOnInit(): void {
    this.destroyToken = new Subject();

    this._route.queryParams
      .pipe(takeUntil(this.destroyToken))
      .subscribe(params => this.onQueryParamsChange(params));

    this._eventBus.watchlistUpdate
      .pipe(takeUntil(this.destroyToken))
      .subscribe(evt => {
        this.onWatchlistUpdate(evt);
      });

    this._router.events
      .pipe(takeUntil(this.destroyToken))
      .subscribe(evt => this.onRouterEvent(evt));

    this._route.params
      .pipe(takeUntil(this.destroyToken))
      .subscribe(evt => this.onParamsChange(evt));

    this._authService.onAuthStateChange
      .pipe(takeUntil(this.destroyToken))
      .subscribe(evt => this.onAuthStateChange(evt));

    const fragment = this._route.snapshot.fragment;
    if (fragment) {
      this._postLoadScrollRequest = fragment;
    }

    this._scrollTrigger.directionChange$
      .pipe(takeUntil(this.destroyToken))
      .subscribe(dir => {
        // since we override lastScrollDirection,
        // it's possible for dir to match lastScrollDirection
        if (this.lastScrollDirection !== dir) {
          this.lastScrollDirection = dir;

          // clear lock since you can override window.scrollTo
          // and it's possible never to reach the target.
          this._tempActiveSectionLock = null;
        }
      });

    this._scrollTrigger.callback$
      .pipe(takeUntil(this.destroyToken))
      .subscribe(() => {
        this.runSectionScrollDetection();
      });

    this._appNavService.setIsMrtSearch(undefined);

    this.desktop$ = this.mediaQueryService.gt(Breakpoint.md);
    this.tablet$ = this.mediaQueryService.lt(Breakpoint.lg);
    this.mobile$ = this.mediaQueryService.lte(Breakpoint.md);

    // make sure to always enable scrolling on desktop
    this.desktop$.subscribe(value => {
      if (value) {
        this.showMobileNav = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyToken.next();
    this.destroyToken.complete();
  }

  ngAfterViewInit(): void {
    // this generates an ExpressionChangedAfterItHasBeenCheckedError.
    // as far as I know, there's no good way to have our cake and eat it too
    // when detecting what sections are enabled in this way. Ideally, the
    // conditions under which sections are enabled should be data-driven
    // rather than template driven.

    this.enabledSectionIds$ = this.pageSections.changes.pipe(
      map((list: QueryList<DetailsPageSectionDirective>) => {
        return list.map(e => e.element.nativeElement.id);
      })
    );

    this.pageSections.changes.subscribe(() => {
      if (this._initialScrollSection) {
        const scrollSection = this._initialScrollSection;

        // delay scrolling until the next tick to allow
        // all the sections to calm down
        setTimeout(() => {
          if (!this.scrollToSection(scrollSection, 'auto')) {
            this.runSectionScrollDetection();
          }
        }, 0);

        this._initialScrollSection = null;
      } else {
        this.runSectionScrollDetection();
      }
    });

    this._followService.isProcessingFollow$.subscribe(value => {
      this.isProcessing = value;
    });

    this._mobileScrollService.isScrollHidden$.subscribe(value => {
      const html = document.querySelector('html');
      if (value) {
        html.classList.add('no-scroll');
      } else {
        html.classList.remove('no-scroll');
      }
    });

    this.runSectionScrollDetection();
  }

  onSlideChange(swiper?: Swiper) {
    const currentIndex = swiper[0].activeIndex;
    if (!this.resizeObservers[currentIndex]) {
      const currentSlide = swiper[0].slides[currentIndex];
      const observer = new ResizeObserver(entries => {
        entries.forEach(entry => {
          if (
            swiper &&
            swiper[0] &&
            swiper[0].$wrapperEl &&
            swiper[0].$wrapperEl[0]
          ) {
            swiper[0].$wrapperEl[0].style.height = `${entry.contentRect.height}px`;
          }
        });
      });

      observer.observe(currentSlide);
      this.resizeObservers[currentIndex] = observer;
    }

    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.setActiveSection(this.sideNavItems[currentIndex].key);
    }, 100);

    jQuery('.tooltip').tooltip('hide');
  }

  handleSideNavClick(item: SideNavItem) {
    this.scrollToSection(item.key);
  }

  private onRouterEvent(evt: Event) {
    if (evt instanceof NavigationEnd) {
      this.onNavigationEnd(evt);
    }
  }

  abstract getAppName(): string;
  abstract getAppOS(): string;
  abstract getStructuredData():
    | StructuredAppData
    | StructuredDomainData
    | StructuredSellerData;
  abstract followApp(): void;
  abstract unfollowApp(): void;

  getNumWatching(watchId: string, type: string) {
    return this._apigeeService
      .getNumWatchingById(watchId, type)
      .then(body => {
        if (body) {
          this._followService.updateNumWatching(body.numFound);
        }
      })
      .catch(error => {
        this._followService.updateNumWatching(0);
      });
  }

  getValidMonthParam(month: string) {
    if (month && month != 'undefined') {
      if (this.isFreemium) {
        const currentMonth = new Date().getMonth() + 1;
        const monthDiff = currentMonth - parseInt(month.substring(4, 6));
        if (monthDiff == 0 || monthDiff == 1) {
          return month;
        }
      } else {
        return month;
      }
    }
    return ''; // invalid month param
  }

  getValidDeviceParam(device: string) {
    if (this.isFreemium) {
      return 'GLOBAL';
    }
    return device;
  }

  handleFollowClick(evt: any) {
    if (this.isFollowing) {
      this.unfollowApp();
    } else {
      this.followApp();
    }
  }

  updateFollowingState(): boolean {
    this.isFollowing = this._watchlistService.isFollowing(
      this.appId,
      this.type
    );
    this._followService.updateIsFollowing(this.isFollowing);

    return this.isFollowing;
  }

  updatePageMetadata() {
    this._pageMetaService.setTitle(this.getAppName(), this.getAppOS());
    this._pageMetaService.setMetaDescription(
      this.getAppName(),
      this.getAppOS()
    );
    this._pageMetaService.setCanonicalURL(this.getCanonicalPath());

    const os = this.getAppOS();
    if (os !== 'domain' && os != 'seller') {
      const structuredAppData: StructuredAppData = <StructuredAppData>(
        this.getStructuredData()
      );
      if (
        structuredAppData.score != null ||
        structuredAppData.appStoreRating != null
      ) {
        const structuredData =
          this._pageMetaService.buildStructuredAppData(structuredAppData);
        this._pageMetaService.setStructuredData(structuredData);
      }
    } else {
      // TODO: on domain
      // build structure data
      // update tag
    }
  }

  getCanonicalPath() {
    const url = this._routerUtility.substituteParams(this._route, {
      region: 'GLOBAL'
    });

    return this._router.serializeUrl(this._router.createUrlTree(url));
  }

  onNavigationEnd(evt: NavigationEnd) {
    if (this.insightsData) {
      this.updatePageMetadata();
    }
  }

  onParamsChange(evt: Params) {}

  onQueryParamsChange(params: Params) {}

  onAuthStateChange(state: AuthState) {}

  onWatchlistUpdate(evt: any) {}

  // Selects the current active section.
  //
  // It does this by finding the section with the largest intersection
  // with a line segment defined as 25% of the visible page (with some vertical offset)
  // this allows for an intuitive selection of the active section
  // that aligns closer with user expectations
  private runSectionScrollDetection() {
    console.assert(
      this.pageHeader,
      'no [mrt-insights-header] defined on the page'
    );

    if (this.swiper?.swiperRef?.$wrapperEl) return; // no section detection on mobile view

    if (this.pageHeader) {
      const headerHeight = this.pageHeader.headerHeight;

      const pageHeight = document.documentElement.clientHeight;

      const pageFocusTop = headerHeight + 120;
      const pageFocusBottom = pageFocusTop + (pageHeight - headerHeight) * 0.1;

      let largestIntersection = 0;
      let closestSection = null;

      for (const section of this.pageSections) {
        const el = section.element.nativeElement;

        const bounds = el.getBoundingClientRect();

        let elClippedTop = bounds.top;
        if (pageFocusTop > elClippedTop) elClippedTop = pageFocusTop;

        let elClippedBottom = bounds.bottom;

        if (pageFocusBottom < elClippedBottom)
          elClippedBottom = pageFocusBottom;

        if (el.id === 'overview') {
          if (bounds.top < 0) {
            this.mobileFilterBreakpointReached = true;
          } else {
            this.mobileFilterBreakpointReached = false;
          }
        }

        // sections below the focus will be negative & ruled out
        // so no need to explicitly check for this case
        const dist = elClippedBottom - elClippedTop;

        if (dist > largestIntersection) {
          largestIntersection = dist;
          closestSection = el;
        }
      }

      if (closestSection) {
        const id = closestSection.id;

        if (this._tempActiveSectionLock) {
          this.setActiveSection(this._tempActiveSectionLock);

          if (this._tempActiveSectionLock === id) {
            this._tempActiveSectionLock = null;
          }
        } else {
          this.setActiveSection(id);
        }
      }
    }
  }

  private setActiveSection(key: string) {
    if (this.activeSection !== key) {
      this.activeSection = key;
      this.activeSectionHint = key;

      let matchingItem = this.sideNavItems.find(item => item.key === key);

      if (!matchingItem) {
        let node = document.getElementById(key);
        node = node.parentElement;
        while (node) {
          if (node.id) {
            matchingItem = this.sideNavItems.find(item => item.key === node.id);
            if (matchingItem) {
              this.activeSection = matchingItem.key;
              break;
            }
          }
          node = node.parentElement;
        }
      }

      let fragment = '';

      if (this.activeSectionHint !== 'overview') {
        fragment = `#${this.activeSectionHint}`;
      }

      const urlPath = `${location.pathname}${location.search}${fragment}`;
      history.replaceState(null, '', urlPath);
    }
  }

  goToSection(anchor: string) {
    this.scrollToSection(anchor.substr(1));
  }

  scrollToSection(key: string, behavior: ScrollBehavior = 'smooth'): boolean {
    const matchingSectionEl = document.getElementById(key);
    if (!matchingSectionEl) {
      return false;
    }

    if (matchingSectionEl.classList.contains('carousel-item')) {
      const children = jQuery(matchingSectionEl.closest('.carousel')).find(
        '.carousel-item'
      );
      const index = children.index(matchingSectionEl);
      jQuery(matchingSectionEl.closest('.carousel')).carousel(index);
      this.setActiveSection(key);
    } else if (this.swiper?.swiperRef?.$wrapperEl) {
      const matchingSectionEl = document.getElementById(key);
      if (!matchingSectionEl) {
        return false;
      }
      const swiperSlide = jQuery(matchingSectionEl.closest('.swiper-slide'));
      const index = jQuery(swiperSlide).data('swiper-slide-index');
      console.log('SWIPING TO INDEX: ', index);
      this.swiper?.swiperRef.slideTo(index);
      this.setActiveSection(key);
    } else {
      const padding = 12;

      const relativeScrollTarget =
        matchingSectionEl.getBoundingClientRect().top;

      const headerHeight = this.pageHeader.headerHeight;

      const targetScroll = relativeScrollTarget - headerHeight - padding;

      window.scrollBy({
        top: targetScroll,
        behavior: behavior
      });

      if (targetScroll < 0) {
        this.lastScrollDirection = 'top';
      } else {
        this.lastScrollDirection = 'bottom';
      }

      this._tempActiveSectionLock = key;
    }

    return true;
  }

  scrollToInitialSection() {
    const section = location.hash;
    if (section) {
      this._initialScrollSection = section.substring(1);
    }
  }

  gotoClaimForm() {
    const current = window.location.href;
    const formURL =
      'https://docs.google.com/forms/d/e/1FAIpQLSeheoVx1oEoUQryWSyFZ6j8HHpihwoYSZLKzm2SvTz2ov5qTw/viewform?entry.1181721194=' +
      encodeURIComponent(current);

    window.open(formURL, '_blank');
  }

  initImgErrors() {
    setTimeout(() => {
      jQuery('img').on('error', evt => {
        if (!evt.target.onerror) {
          jQuery(evt.target).attr('src', '/assets/images/logo-grey-16x16.png');
        }
      });
    }, 300);
  }

  initTooltips() {
    setTimeout(() => {
      jQuery('*[title]').tooltip({
        container: 'body',
        html: true,
        animation: false
      });
    }, 200);
  }

  getMonthLabel(options: any[], month: string): string {
    const foundMonth = options.filter(option => option.value === month)[0];
    return foundMonth?.label;
  }

  getMainFilterItem(mainFilterItems: any, key: string): any {
    return mainFilterItems.filter(filter => filter.key === key)[0];
  }

  getMainFilterItemSelectedValue(mainFilterItems: any, key: string) {
    const selectedOption = this.getMainFilterItem(mainFilterItems, key);
    return selectedOption?.selected?.value;
  }
}
